import { useEffect } from 'react'

/**
 * Add keydown event listener for document
 *
 * @param callback - function that calls when the specified key pressed
 * @param key - key KeyboardEvent property
 * @param dependencies - array of dependencies (optional)
 */
export const useKeyDown = (callback: Function, key: string, dependencies?: any[]) => {
  useEffect(() => {
    const keydownHandler = (e: KeyboardEvent) => {
      if (e.key !== key) return
      e.stopPropagation()

      if (key === ' ') {
        // checking for keyboard accessibility (no focus on elements)
        if (document.activeElement === document.body) callback()
      } else {
        callback()
      }
    }

    document.addEventListener('keydown', keydownHandler)

    return () => {
      document.removeEventListener('keydown', keydownHandler)
    }
  }, dependencies)
}
